/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import InboundRequestLogService from '../../service/inbound-request-log-service';
import Pasoonate from "pasoonate";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import { Modal } from "react-bootstrap";
import { JSONTree } from "react-json-tree";

const inboundRequestLogService = new InboundRequestLogService();

await loadDictionary('inbound-request-log-details-window');

function DetailsInboundRequestLogWindow({isOpenWindow, onCloseWindow, requestLogId}) {
    const [requestLog, setRequestLog] = useState(null);

    const handleClose = () => {
        onCloseWindow();
    };

    useEffect(() => {
        if(!isOpenWindow || !requestLogId) return;

        inboundRequestLogService.findOne(requestLogId).then(requestLog => {
            requestLog.created_at = requestLog?.created_at ? Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', requestLog.created_at) : null;

            setRequestLog(requestLog);
        });

    }, [isOpenWindow, requestLogId]);

    return (
        <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={true} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    {i18n.t("inbound-request-log-details-window.title")}
                    <span className="badge bg-success ms-2 fs-6 fw-normal">{requestLog?.status_code}</span>
                    <span className="badge bg-secondary ms-2 fs-6 fw-normal">{requestLog?.method}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row border rounded">
                    <div className="col-lg-4 col-12 border-end py-2">
                        <div className="text-secondary">Endpoint</div>
                        <div dir="ltr" className="text-start">{requestLog?.endpoint}</div>
                    </div>
                    <div className="col-lg-3 col-12 border-end py-2">
                        <div className="text-secondary">IP</div>
                        <div dir="ltr" className="text-start">{requestLog?.ip_address}</div>
                    </div>
                    <div className="col-lg-3 col-12 border-end py-2">
                        <div className="text-secondary">Execution Time</div>
                        <div dir="ltr" className="text-start">{Number(requestLog?.execution_time).toFixed(3)}</div>
                    </div>
                    <div className="col-lg-2 col-12 py-2">
                        <div className="text-secondary">User ID</div>
                        <div dir="ltr" className="text-start">{requestLog?.user_id}</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-12" dir="ltr">
                        <JSONTree data={requestLog?.request_data} />
                    </div>
                    <div className="col-lg-12 col-12" dir="ltr">
                        <JSONTree data={requestLog?.response_data} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default DetailsInboundRequestLogWindow;